import PropTypes from 'prop-types';
import * as React from 'react';

import styles from './ValidationMessage.less';

const ValidationMessage = ({hasError, message, isValid}) => {
  const DivOrSpan = isValid ? 'span' : 'div';
  return hasError ? (
    <DivOrSpan className={styles.dlValidationMessage}>
      <span className={styles.dlLabelPlaceholder} />
      <DivOrSpan className={styles.dlValidationMessageText}>
        {message}
      </DivOrSpan>
    </DivOrSpan>
  ) : null;
};

ValidationMessage.propTypes = {
  hasError: PropTypes.bool,
  message: PropTypes.string,
};

ValidationMessage.defaultProps = {
  hasError: false,
  message: '',
};

export default ValidationMessage;
